export function cleanOidcUrl(href: string): URL {
  const url = new URL(href);
  for (const param of [
    "state", "code", "session_state", "iss", "error", "error_description", "error_uri",
    "kc_action", "kc_action_status",
  ]) url.searchParams.delete(param);
  url.hash = "";
  return url;
}
